import { typedQueryClient, useTypedMutation } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { AppointmentsQueryKeys } from "modules/Appointments/queryKeys";
import { sortAppointments } from "modules/Appointments/util";
import { ApiInstance } from "utils/Api";

import type { DealerLocation } from "models";

type AppointmentPinPayload = {
  appointment_id: number;
  is_pinned: boolean;
  is_pinned_manually: boolean;
};

export const useAppointmentPinMutation = (location?: DealerLocation) =>
  useTypedMutation<AppointmentPinPayload, void>({
    mutationFn: async payload => {
      await ApiInstance.post("/appointments/is_pinned/update", payload);
    },
    onSuccess: ({ appointment_id, is_pinned, is_pinned_manually }) => {
      const appointment = typedQueryClient.getQueryData(AppointmentDetailsKeys.view);
      if (appointment) typedQueryClient.setQueryData(AppointmentDetailsKeys.view, { ...appointment, is_pinned, is_pinned_manually });

      const appointments = typedQueryClient.getQueryData(AppointmentsQueryKeys.list);
      if (!appointments?.length) return;

      const appointmentIdx = appointments.findIndex(appointment => appointment.id === appointment_id);
      if (appointmentIdx === -1) return;

      typedQueryClient.setQueryData(
        AppointmentsQueryKeys.list,
        sortAppointments(appointments.with(appointmentIdx, { ...appointments[appointmentIdx], is_pinned, is_pinned_manually }), location?.statuses)
      );
    }
  });
